import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject, ChangeDetectionStrategy, effect, untracked,
} from '@angular/core';
import { AppService, NotificationTemplatesAccessService, SessionService, WorkspaceMeService } from '../../services';
import { AmSuiteTelemetryService } from '@neworg-net/amsuite-core/telemetry';
import { UserProperty, AppProperty } from '../../properties';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { AppStateHolder } from '../../shared';
import { DrawerModule } from 'primeng/drawer';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DrawerModule, Ripple, ButtonDirective, TranslateModule]
})
export class UserMenuComponent implements OnInit, OnChanges {
  userProperty = inject(UserProperty);
  private _appService = inject(AppService);
  appStateHolder = inject(AppStateHolder);
  appProperty = inject(AppProperty);
  sessionService = inject(SessionService);
  private _appInsightsService = inject(AmSuiteTelemetryService);
  private _router = inject(Router);
  appComponent = inject(AppComponent);
  workspaceMe = inject(WorkspaceMeService);
  notificationTemplatesAccess = inject(NotificationTemplatesAccessService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
    // La voce «Template notifiche» la decide il Notifier. La capability si chiede a sessione completa
    // (azienda scelta): il menu nasce con la shell, anche sulla pagina di login, quando la richiesta
    // partirebbe senza utente. Un errore non resta in memoria: riprovano l'apertura del menu e il guard.
    effect(() => {
      if (this.appProperty.dataLoaded()) {
        untracked(() => this.notificationTemplatesAccess.ensureLoaded().subscribe());
      }
    });
  }

  @Input() visible: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();


  /** Mobile: drawer dal basso (bottom sheet); desktop: laterale destro. */
  get drawerPosition(): 'right' | 'bottom' {
    return window.innerWidth <= 640 ? 'bottom' : 'right';
  }

  canManageAccountSettings: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    // Dopo un errore all'avvio la voce comparirebbe solo ricaricando: il menu che si apre riprova. Con la
    // capability già in memoria non parte niente.
    if (changes['visible']?.currentValue && this.appProperty.dataLoaded()) {
      this.notificationTemplatesAccess.ensureLoaded().subscribe();
    }
  }

  ngOnInit(): void {
    // All users are B2C now — account settings managed in B2C portal
    this.canManageAccountSettings = false;
  }

  changePassword() {
    this._router.navigate(['/app', 'password-1']);
  }

  signOut(): void {
    this.closeSidebar();
    this._appInsightsService.clearUserId();
    this.appStateHolder.signOut();
  }

  navigateToAccountSettings() {
    this.closeSidebar();
    this._router.navigate(['/accountSettings']);
  }

  navigateToPreferences() {
    this.closeSidebar();
    this._router.navigate(['/preferences']);
  }

  navigateToNotifications() {
    this.closeSidebar();
    this._router.navigate(['/notifications']);
  }

  /** Gestione template dashboard (feature C); voce visibile solo ai gestori. */
  navigateToManageTemplates() {
    this.closeSidebar();
    this._router.navigate(['/managetemplates']);
  }

  /** Testi delle email personalizzati per azienda (#2103); voce visibile solo a chi il Notifier riconosce. */
  navigateToNotificationTemplates() {
    this.closeSidebar();
    this._router.navigate(['/notifications/templates']);
  }


  closeSidebar() {
    this.close.emit(true);
  }
}
